export const REIMBURSEMENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const REIMBURSEMENT_STATUS_LABELS = {
  [REIMBURSEMENT_STATUS.PENDING]: 'Pending',
  [REIMBURSEMENT_STATUS.APPROVED]: 'Approved',
  [REIMBURSEMENT_STATUS.REJECTED]: 'Rejected',
  [REIMBURSEMENT_STATUS.CANCELLED]: 'Cancelled',
};

export const REIMBURSEMENT_STATUS_COLORS = {
  [REIMBURSEMENT_STATUS.PENDING]: 'warning',
  [REIMBURSEMENT_STATUS.APPROVED]: 'success',
  [REIMBURSEMENT_STATUS.REJECTED]: 'error',
  [REIMBURSEMENT_STATUS.CANCELLED]: 'default',
};

export const INITIAL_REIMBURSEMENT_FORM_STATE = {
  date: null,
  description: '',
  amount: '',
  attachmentKey: '',
  attachmentUrl: '',
  reviewers: [],
};
